<template>
    <span>
        (click <a href="javascript:void()" @click="showModal = true">here</a> to learn more).

        <modal
            v-if="showModal"
            @close="showModal = false"
            modal-width="600px;"
        >

            <h4 slot="header">
                 Illinois Energy Efficiency Loan Program
            </h4>

            <div slot="body" class="loan-program-dialog-body">
                 You may be eligible to finance energy efficiency improvements with low-cost, low-payment, on-bill financing through the Illinois Energy Efficiency Loan Program.<br><br>
                Apply for financing approval through AFC First using the application form at ilenergyloan.com or call 888-269-3133 for additional information.<br><br>
                If on-bill financing is pursued, final-approval from AFC First is required before project work can begin. AFC First and the program will coordinate project funding, upon loan and project approval.
                <br><br>
            </div>

        </modal>
    </span>
</template>
<script>
    export default {


        data() {
            return {
                showModal: false
            }
        }
    }
</script>
